import ComplementoINE from './ComplementoINE';
import ComplementoDonatarias from './ComplementoDonatarias';
import ComplementoCartaPorte from './ComplementoCartaPorte';
import ComplementoAerolineas from './ComplementoAerolineas';
import ComplementoVehiculosUsados from './ComplementoVehiculosUsados';
import ComplementoComercioExterior from './ComplementoComercioExterior';
import ComplementoImpuestosLocales from './ComplementoImpuestosLocales';
import ComplementoParcialesConstruccion from './ComplementoParcialesConstruccion';

const complementosList = {
  INE: ComplementoINE,
  Donatarias: ComplementoDonatarias,
  CartaPorte: ComplementoCartaPorte,
  VehiculoUsado: ComplementoVehiculosUsados,
  parcialesconstruccion: ComplementoParcialesConstruccion,
  ComercioExterior: ComplementoComercioExterior,
  ImpuestosLocales: ComplementoImpuestosLocales,
  Aerolineas: ComplementoAerolineas,
}

export default complementosList;